import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import classes from "../basicinformation/BasicInformation.module.css";
import doctor_profile_default from "../../../../assets/images/doctor-thumb-default.jpg";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import { GENDER } from "./BasicInfoDummyData";
import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Stack,
  Typography,
  Avatar,
  Grid,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import {
  getRequest,
  postAxios,
  singoutHandler,
} from "../../../../api/AxiosAPICall";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import DateComponent from "../../../commoncomponents/input/DateComponent";
import {
  getDatefromSqlDate,
  restictDotHyphenAnde,
} from "../../../../util/GenralUtils";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { useNavigate } from "react-router-dom";
const BasicInformation = ({
  formik,
  sendBasicinformation,
  loader,
  sendSocialMediaLoader,
  sendCloseSnackbar,
  CheckDuplicateUserEmail,
  isUserEmailPresent,
  CheckDuplicateUserMobile,
  isUserMobilePresent,
}: {
  formik: any;
  sendBasicinformation: any;
  loader: any;
  sendSocialMediaLoader: any;
  sendCloseSnackbar: any;
  CheckDuplicateUserEmail: any;
  isUserEmailPresent: any;
  CheckDuplicateUserMobile: any;
  isUserMobilePresent: any;
}) => {
  const [uploadProfile, setUploadProfile] = useState(false);
  const [departments, setDepartments] = useState<any>([]);
  const [uploadProfileCheck, setUploadProfileCheck] = useState(false);
  const [photoUpload, setPhotoUpload] = useState("");
  const [open, setOpen] = useState(false);
  const [socialMediaLoader, setSocialMediaLoader] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState<any>("");
  const [fileSelect, setFileSelect] = useState(false);
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const isMounted = useRef<any>();
  const dispatch = useDispatch();
  let history = useNavigate();

  const onChange = (event: any) => {
    const files = event?.target?.files;
    const file = files[0];
    if (
      /\.(jpg|jpeg|png|gif|bmp)$/.test(file?.name) === false ||
      file?.size >= 2097152
    ) {
      setFileTypeCheck("incompatible");
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let chooseImage = String(reader?.result);
        setPhotoUpload(chooseImage.substring(chooseImage.indexOf(",") + 1));
        setUploadProfile(true);
        setFileSelect(false);
        setFileTypeCheck("compatible");
      };
    }
  };

  const photoUploadJson = {
    base64Image: photoUpload,
  };

  const onSubmitFile = async (event: any) => {
    event.preventDefault();
    if (
      uploadProfile === true &&
      photoUploadJson.base64Image !== "" &&
      photoUploadJson.base64Image !== undefined
    ) {
      const response = await postAxios(
        "uploadFile",
        { imageBase64: photoUploadJson.base64Image },

        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        singoutHandler(jwtToken);
        localStorage.removeItem("token");
        history("/signin");
      } else if (response.data === true) {
        setUploadProfileCheck(false);
        setFileSelect(false);
        setUploadProfile(false);
        dispatch(
          setSnackbar(
            true,
            4000,
            "success",
            "Profile picture successfully uploaded",
            "top",
            "center"
          )
        );
      } else {
        setUploadProfile(false);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Unable to upload profile picture",
            "top",
            "center"
          )
        );
      }
    }
  };
  const fetchDepartments = useCallback(async () => {
    isMounted.current = true;
    const response = await getRequest("establishmentListItems/estId", {
      params: {
        applistName: "Department Name",
      },
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      setDepartments(response?.data);
    }
  }, [dispatch, jwtToken]);

  useEffect(() => {
    jwtToken && fetchDepartments();
    return () => {
      isMounted.current = false;
      setDepartments([]);
    };
    // eslint-disable-next-line
  }, []);
  const fetchProfileDetailsData = useCallback(async () => {
    setOpen(true);
    setSocialMediaLoader(true);
    const response = await getRequest(
      "establishmentProfessionals/profileDetails",
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response?.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response?.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
      singoutHandler(jwtToken);
      localStorage.removeItem("token");
      history("/signin");
    } else {
      sendBasicinformation(response?.data);
      let basicinformationData = response?.data;
      if (basicinformationData !== undefined) {
        setPhotoUpload(basicinformationData.profilePicture);
        formik.setFieldValue("userName", basicinformationData?.useUsername);
        formik.setFieldValue("firstName", basicinformationData?.useFirstname);
        formik.setFieldValue("lastName", basicinformationData?.useSurname);

        if (
          basicinformationData?.useEmail !== undefined &&
          basicinformationData?.useEmail !== null &&
          basicinformationData?.useEmail !== ""
        ) {
          formik.setFieldValue("emailId", basicinformationData?.useEmail);
        }

        if (
          basicinformationData?.useGender !== undefined &&
          basicinformationData?.useGender !== null &&
          basicinformationData?.useGender !== ""
        ) {
          let gender: string;

          switch (basicinformationData.useGender) {
            case "M":
              gender = "M";
              break;
            case "F":
              gender = "F";
              break;
            default:
              gender = "U";
          }
          formik.setFieldValue("gender", gender);
        }

        if (
          basicinformationData?.useMobile !== undefined &&
          basicinformationData?.useMobile !== null &&
          basicinformationData?.useMobile !== ""
        ) {
          formik.setFieldValue("mobileNo", basicinformationData.useMobile);
        }

        if (
          basicinformationData?.additionalDetails.eleMbttNumber !== undefined &&
          basicinformationData?.additionalDetails.eleMbttNumber !== null &&
          basicinformationData?.additionalDetails.eleMbttNumber !== ""
        ) {
          formik.setFieldValue(
            "mbttNumber",
            basicinformationData?.additionalDetails.eleMbttNumber
          );
        }

        //Additional details
        let basicinformationAdditional = response?.data;

        if (
          basicinformationAdditional?.additionalDetails?.eleDob !== undefined &&
          basicinformationAdditional?.additionalDetails?.eleDob !== null &&
          basicinformationAdditional?.additionalDetails?.eleDob !== ""
        ) {
          formik.setFieldValue(
            "birthDate",
            getDatefromSqlDate(
              basicinformationAdditional?.additionalDetails?.eleDob
            )
          );
        }

        if (
          basicinformationAdditional?.additionalDetails?.eleYearOfExperience !==
            undefined &&
          basicinformationAdditional?.additionalDetails?.eleYearOfExperience !==
            null
        ) {
          formik.setFieldValue(
            "totalExperiance",
            basicinformationAdditional?.additionalDetails?.eleYearOfExperience
          );
        }

        if (
          departments !== null &&
          departments !== "" &&
          basicinformationAdditional?.additionalDetails
            ?.eleDepartmentEliName !== undefined
        ) {
          let isMatched = false;

          departments.forEach((element: any) => {
            if (
              element.eliText ===
              basicinformationAdditional?.additionalDetails
                ?.eleDepartmentEliName
            ) {
              isMatched = true;

              return false;
            }
          });

          if (!isMatched) {
            const department = {
              eliId:
                basicinformationAdditional?.additionalDetails
                  ?.eleDepartmentEliId,
              eliText:
                basicinformationAdditional?.additionalDetails
                  ?.eleDepartmentEliName,
            };

            setDepartments([...departments, department]);

            formik.setFieldValue(
              "eliId",
              basicinformationAdditional?.additionalDetails?.eleDepartmentEliId
            );
            formik.setFieldValue(
              "department",
              basicinformationAdditional?.additionalDetails
                ?.eleDepartmentEliName
            );
          } else {
            formik.setFieldValue(
              "eliId",
              basicinformationAdditional?.additionalDetails?.eleDepartmentEliId
            );
            formik.setFieldValue(
              "department",
              basicinformationAdditional?.additionalDetails
                ?.eleDepartmentEliName
            );
          }
        }
        if (
          basicinformationAdditional?.additionalDetails?.eleBiography !==
            undefined &&
          basicinformationAdditional?.additionalDetails?.eleBiography !==
            null &&
          basicinformationAdditional?.additionalDetails?.eleBiography !== ""
        ) {
          formik.setFieldValue(
            "biography",
            basicinformationAdditional?.additionalDetails?.eleBiography
          );
        }
      }
      setOpen(false);
      sendSocialMediaLoader(socialMediaLoader);
      sendCloseSnackbar("basicinformationSnackbar");
    }
    // eslint-disable-next-line
  }, [dispatch, jwtToken, departments, loader]);

  useEffect(() => {
    jwtToken && fetchProfileDetailsData();
    // eslint-disable-next-line
  }, [departments, loader]);

  return (
    <CommonCard>
      <Typography variant="h6" className={globalClasses.typography}>
        Basic Information
      </Typography>
      {open && (
        <Box className={globalClasses.loader}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {!open && (
        <>
          <Avatar
            src={
              photoUpload
                ? `data:image/jpeg;base64,${photoUpload}`
                : `${doctor_profile_default}`
            }
            id="myfile"
            variant="square"
            className={classes.profilePic}
            imgProps={{ className: classes.profilePicSize }}
            alt="test"
          />
          <Box marginBottom="20px">
            <Grid>
              <form onSubmit={onSubmitFile}>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    component="label"
                    className={classes.uploadFileButton}
                    onClick={() => {
                      setUploadProfileCheck(false);
                      setFileSelect(true);
                    }}
                  >
                    Choose File
                    <input
                      id="myfile"
                      name="myfile"
                      type="file"
                      hidden
                      onChange={onChange}
                      accept=".png, .jpg, .jpeg, .bmp"
                    />
                  </Button>

                  <ButtonComponent
                    className={classes.uploadFileButton}
                    label="Upload"
                    onClick={() => {
                      setUploadProfileCheck(true);
                      setFileSelect(false);
                    }}
                  />
                </Stack>
                {uploadProfile === false && uploadProfileCheck === true && (
                  <Typography className={classes.profileMessage}>
                    Please select profile picture
                  </Typography>
                )}
                {fileTypeCheck === "incompatible" &&
                  fileTypeCheck !== "" &&
                  fileSelect === true && (
                    <Typography className={classes.profileMessage}>
                      Applicant image should be less than 2Mb and one of the
                      following file types BMP, JPG, JPEG, PNG.
                    </Typography>
                  )}
              </form>
            </Grid>
          </Box>
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} md={4}>
              <InputField
                id="userName"
                name="userName"
                label="User Name"
                inputvalues={formik.values.userName}
                errormessage={
                  formik.touched.userName && Boolean(formik.errors.userName)
                }
                message={formik.touched.userName && formik.errors.userName}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={true}
                disable={true}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <InputField
                id="firstName"
                name="firstName"
                label="First Name"
                inputvalues={formik.values.firstName}
                errormessage={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                message={formik.touched.firstName && formik.errors.firstName}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <InputField
                id="lastName"
                name="lastName"
                label="Last Name"
                inputvalues={formik.values.lastName}
                errormessage={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                message={formik.touched.lastName && formik.errors.lastName}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <InputField
                id="emailId"
                name="emailId"
                label="Email"
                inputvalues={formik.values.emailId}
                errormessage={
                  formik.touched.emailId && Boolean(formik.errors.emailId)
                }
                message={formik.touched.emailId && formik.errors.emailId}
                changeevent={(event: any, value: any) => {
                  formik.handleChange("emailId")(event);
                  CheckDuplicateUserEmail(event?.target?.value);
                }}
                blurevent={(event: any, value: any) => {
                  formik.handleBlur("emailId")(event);
                  CheckDuplicateUserEmail(event.target.value);
                }}
                isrequired={true}
              />
              {isUserEmailPresent && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  Email already exists
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={4}>
              <DateComponent
                label="Birth Date"
                value={formik.values.birthDate}
                onChange={(newValue: Date | null) => {
                  formik.setFieldValue("birthDate", newValue);
                }}
                inputId="birthDate"
                inputName="birthDate"
                inputValue={formik.values.birthDate}
                error={
                  formik.touched.birthDate && Boolean(formik.errors.birthDate)
                }
                helperText={formik.touched.birthDate && formik.errors.birthDate}
                inputOnBlur={formik.handleBlur}
                inputOnChange={(newValue: Date | null) => {
                  formik.setFieldValue("birthDate", newValue);
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <InputField
                id="mobileNo"
                name="mobileNo"
                label="Enter Mobile Number"
                type="number"
                inputvalues={formik.values.mobileNo}
                errormessage={
                  formik.touched.mobileNo && Boolean(formik.errors.mobileNo)
                }
                message={formik.touched.mobileNo && formik.errors.mobileNo}
                changeevent={(event: any, value: any) => {
                  formik.handleChange("mobileNo")(event);
                  CheckDuplicateUserMobile(event.target.value);
                }}
                blurevent={(event: any, value: any) => {
                  formik.handleBlur("mobileNo")(event);
                  CheckDuplicateUserMobile(event.target.value);
                }}
                downevent={restictDotHyphenAnde}
                isrequired={true}
                placeholder="e.g. 8888888888"
              />
              {isUserMobilePresent && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  Mobile Number already exists
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={4}>
              <SelectField
                id="gender"
                headerText="Gender"
                name="gender"
                label="Gender"
                list={GENDER.map((option: any) => {
                  return (
                    <MenuItem key={option.id} value={option.value}>
                      {option.text}
                    </MenuItem>
                  );
                })}
                value={formik.values.gender}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange("gender")}
                error={formik.touched.gender && Boolean(formik.errors.gender)}
                isrequired={true}
              />
              {formik.touched.gender && formik.errors.gender && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  {formik.errors.gender}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={4}>
              <InputField
                id="totalExperiance"
                name="totalExperiance"
                type="number"
                label="Total Years of Experience"
                inputvalues={formik.values.totalExperiance}
                changeevent={(event: any) => {
                  event.target.value.length <= 2 &&
                    formik.handleChange("totalExperiance")(event);
                }}
                blurevent={formik.handleBlur}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <input
                type="hidden"
                id="eliId"
                name="eliId"
                value={formik?.values?.eliId ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <SelectField
                id="department"
                name="department"
                headerText="Department"
                label="Department"
                changeevent={(event: any, newValue: any) => {
                  formik.handleChange("department")(event);
                  formik.setFieldValue("eliId", newValue.props.id ?? "");
                }}
                blurevent={formik.handleBlur}
                value={formik.values.department}
                error={
                  formik.touched.department && Boolean(formik.errors.department)
                }
                isrequired={true}
                list={departments?.map((department: any) => (
                  <MenuItem
                    id={department.eliId}
                    key={department.eliId}
                    value={department.eliText}
                  >
                    {department.eliText}
                  </MenuItem>
                ))}
              />

              {formik.touched.department && formik.errors.department && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  {formik.errors.department}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <InputField
                id="mbttNumber"
                name="mbttNumber"
                label="MBTT Number"
                inputvalues={formik.values.mbttNumber}
                errormessage={
                  formik.touched.mbttNumber && Boolean(formik.errors.mbttNumber)
                }
                message={formik.touched.mbttNumber && formik.errors.mbttNumber}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} md={4}>
              <Typography variant="h6" className={globalClasses.typography}>
                About Me (Biography)
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} xl={12}>
              <Stack alignItems="left">
                <TextField
                  id="biography"
                  name="biography"
                  value={formik.values.biography}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-label="Biography"
                  placeholder="Biography"
                  fullWidth
                  error={
                    formik.touched.biography && Boolean(formik.errors.biography)
                  }
                  helperText={
                    formik.touched.biography && formik.errors.biography
                  }
                  InputProps={{
                    inputComponent: TextareaAutosize,
                    inputProps: {
                      style: {
                        resize: "none",
                      },
                    },
                  }}
                  className={classes.textArea}
                />
              </Stack>
            </Grid>
          </Grid>
        </>
      )}
    </CommonCard>
  );
};
export default BasicInformation;
